export default [
  {
    path: '/error-404',
    name: 'error-404',
    component: () => import('@/views/error/Error404.vue'),
    meta: {
      authRequired: false,
      layout: 'full',
      resource: 'Auth',
      action: 'read',
    },
  },
  {
    path: '/login',
    name: 'auth-login',
    component: () => import('@/views/pages/authentication/Login'),
    meta: {
      authRequired: false,
      layout: 'full',
      resource: 'Auth',
      redirectIfLoggedIn: true,
    },
  },
  {
    path: '/forgot-password',
    name: 'forgot-password',
    component: () => import('@/views/pages/authentication/ForgotPassword.vue'),
    meta: {
      authRequired: false,
      layout: 'full',
      resource: 'Auth',
      redirectIfLoggedIn: true,
    },
  },
  {
    path: '/reset-password/:token',
    name: 'reset-password',
    component: () => import('@/views/pages/authentication/ResetPassword.vue'),
    meta: {
      authRequired: false,
      layout: 'full',
      resource: 'Auth',
      redirectIfLoggedIn: true,
    },
  },
  {
    key: 'agent:view.register',
    path: '/register',
    name: 'register',
    route: 'register',
    component: () => import('@/views/pages/authentication/Register.vue'),
    meta: {
      layout: 'full',
      authRequired: false,
      isAppMenu: false,
    },
  },
  {
    key: 'register_success',
    path: '/register-success',
    name: 'register_success',
    route: 'register_success',
    component: () => import('@/views/pages/authentication/RegisterSuccess.vue'),
    meta: {
      layout: 'full',
      authRequired: false,
      isAppMenu: false,
    },
  },
  {
    key: 'environment',
    path: '/environment',
    name: 'environment',
    route: 'environment',
    component: () =>
      import('@/views/pages/authentication/EnvironmentSelection.vue'),
    meta: {
      layout: 'full',
      authRequired: false,
      isAppMenu: false,
    },
  },
  {
    path: '/pages/miscellaneous/under-maintenance',
    name: 'misc-under-maintenance',
    component: () => import('@/views/pages/miscellaneous/UnderMaintenance.vue'),
    meta: {
      layout: 'full',
      authRequired: false,
    },
  },
  {
    path: '/pages/miscellaneous/error',
    name: 'misc-error',
    component: () => import('@/views/pages/miscellaneous/Error.vue'),
    meta: {
      layout: 'full',
      authRequired: false,
    },
  },
]
